import { useRef, useMemo } from 'react';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { getCardHeight } from '@web-mail/utils/mailCardUtil';
import { getCardHeight as getLongCardHeight } from '../../common/components/vlistCards/MailCard/MailCardLong';
const useListDiffFouceRender = (mailDataList, searchList, isSearching, isLeftRight) => {
    const [descChecked] = useState2RM('configMailListShowDesc');
    const [attachmentChecked] = useState2RM('configMailListShowAttachment');
    const [mailConfigListTightness] = useState2RM('configMailListTightness');
    const listPreConfigRef = useRef({
        listPreLength: 0,
        listPreHeight: 0,
        isInit: true,
        preIds: '',
    });
    const mailIdList = useMemo(() => {
        var _a, _b;
        const list = isSearching ? searchList : mailDataList;
        return (_b = (_a = list) === null || _a === void 0 ? void 0 : _a.map(item => item === null || item === void 0 ? void 0 : item.id)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, [mailDataList, searchList, isSearching]);
    const mailTopKeyStr = useMemo(() => {
        var _a, _b;
        const list = isSearching ? searchList : mailDataList;
        return (_b = (_a = list) === null || _a === void 0 ? void 0 : _a.map(item => { var _a; return (((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.top) ? '1' : '0'); })) === null || _b === void 0 ? void 0 : _b.join('');
    }, [mailDataList, searchList, isSearching]);
    const MailListHeightChange = useMemo(() => {
        const { listPreLength, listPreHeight, isInit, preIds } = listPreConfigRef.current;
        const list = (isSearching ? searchList : mailDataList) || [];
        try {
            if (listPreLength === (list === null || list === void 0 ? void 0 : list.length) && mailIdList == preIds && !isInit) {
                let sum = 0;
                if (isLeftRight) {
                    list === null || list === void 0 ? void 0 : list.forEach(item => {
                        sum += getCardHeight(item, isSearching);
                    });
                }
                else {
                    list === null || list === void 0 ? void 0 : list.forEach(item => {
                        sum += getLongCardHeight(item, isSearching);
                    });
                }
                listPreConfigRef.current.listPreHeight = sum;
                listPreConfigRef.current.preIds = mailIdList;
                listPreConfigRef.current.listPreLength = list.length;
                return sum;
            }
            else {
                listPreConfigRef.current.isInit = false;
                listPreConfigRef.current.preIds = mailIdList;
                listPreConfigRef.current.listPreLength = list.length;
                return listPreHeight;
            }
        }
        catch (e) {
            console.log('[MailListHeightChange Error]', e);
        }
        return listPreHeight;
    }, [mailDataList, searchList]);
    const frCount = useRef(0);
    const listFouceRender = useMemo(() => {
        frCount.current++;
        return frCount.current;
    }, [mailConfigListTightness, descChecked, attachmentChecked, MailListHeightChange, mailTopKeyStr]);
    return listFouceRender;
};
export default useListDiffFouceRender;
